import { render, staticRenderFns } from "./CampaignLayout.vue?vue&type=template&id=2368048a&"
import script from "./CampaignLayout.vue?vue&type=script&lang=js&"
export * from "./CampaignLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports